<template>
  <div id="app" class="width100 height100">
    <!-- <img src="./assets/logo.png">
    <router-view/> -->
    <!-- <div class="image-container">
      <img src="./assets/image/bg.b293e7a1.webp" />
    </div> -->

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue